import React, { useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import { useStudent } from '../../DataStore/StudentContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const AlertDefaultContact = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const { setMakeDefaultContact, makeDefaultContact,  getStudentContacts, studentId} = useStudent();


    const handleClose = () => setMakeDefaultContact({ show: false, contact: null });


   if (!makeDefaultContact.contact) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxStudent.makeDefaultContact(makeDefaultContact.contact.id);
        setLoading(false);
        if(server_response.status === "OK"){
            getStudentContacts(studentId); // Refresh contacts
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={makeDefaultContact.show}
            onClose={handleClose}
            title="Make Default Contact"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm 
                    </button>
                    </>}
                </>
            }
        >


            {makeDefaultContact.contact && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want to make <i>{makeDefaultContact.contact.contact_name}</i> the default contact for this student ?</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>Default contact will be used for sending out sms notifications and also appear on lists.
                </p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDefaultContact;
